<template>
  <md-card>
    <md-card-content>
      <h5 class="dayLabel">{{ data.dayLabel }} {{ data.dateLabel }}</h5>
      <h5 v-if="data.isNationalHoliday">{{ data.nationalHolidayLabel }}</h5>
      <table v-if="!data.isNationalHoliday">
        <tbody>
          <template v-for="(group, groupIndex) in data.groups">
            <tr v-if="showGroupName(groupIndex)" :key="groupIndex">
              <td colspan="2">
                <h5 class="groupLabel">
                  {{ data.groups[groupIndex].name }}
                </h5>
              </td>
            </tr>
            <template
              v-for="(route, routeIndex) in data.groups[groupIndex].routes"
            >
              <tr :key="groupIndex + '-' + routeIndex">
                <td colspan="2">
                  {{ route.name }}
                </td>
              </tr>
              <tr
                v-for="(shift, shiftIndex) in route.shifts"
                :key="groupIndex + '-' + routeIndex + '-' + shiftIndex"
              >
                <td>
                  {{ formatTime(shift.beginTime) }}
                </td>
                <td>
                  <schedule-editor-item
                    :disabled="disabled"
                    v-model="data"
                    :data="data"
                    :help-tool-tips-enabled="helpToolTipsEnabled"
                    :driver-details="driverDetails"
                    :language-details="languageDetails"
                    :data-day-index="dataDayIndex"
                    :data-group-index="groupIndex"
                    :data-route-index="routeIndex"
                    :data-shift-index="shiftIndex"
                    :data-max-shifts-per-day="dataMaxShiftsPerDay"
                  ></schedule-editor-item>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </md-card-content>
  </md-card>
</template>

<script>
import scheduleEditorItem from "./ScheduleEditorItem.vue";

export default {
  data() {
    return {};
  },
  mounted() {
    // console.log('Component mounted.')
  },
  watch: {
    // day: function (newValue, oldValue) {
    //     console.log("Day changed");
    // }
    data: {
      handler(val) {
        // console.log("Day change " + val);
        // this.$emit('change', newValue); // @todo Check if needed
      },
      deep: true
    }
  },
  components: {
    scheduleEditorItem: scheduleEditorItem
  },
  props: [
    "helpToolTipsEnabled",
    "driverDetails",
    "languageDetails",
    "data",
    "dataDayIndex",
    "disabled",
    "dataMaxShiftsPerDay"
  ],
  methods: {
    formatTime: function(time) {
      return time.substr(0, 5);
    },
    showGroupName: function(groupIndex) {
      if (
        this.data.groups.length > 1 &&
        this.data.groups[groupIndex].routes.length > 0 &&
        this.data.groups[groupIndex].name !== ""
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.md-card {
  margin-top: 5px;
  margin-bottom: 5px;
}

.md-card .md-card-content h5.dayLabel,
.md-card .md-card-content h5.groupLabel {
  font-weight: bolder;
  margin-top: 15px;
  margin-bottom: 10px;
}

.md-card .md-card-content table {
  width: 100%;
}
</style>
